
export const fetchStageList = async (competitionId) => {
  console.log('ResultsApi: fetchStageList called with competitionId:', competitionId);
  try {
    const response = await fetch('https://www.admin.racepulse.pl/api/monitGetStageList', {
      method: 'POST', // Use POST method to send the CompetitionID in the body
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': 'UYwkNH50yAFoHI1mR62E', // Add the x-api-key header
      },
      body: JSON.stringify({
        CompetitionID: String(competitionId), // Include CompetitionID in the request body
      }),
    });

    console.log('ResultsApi: fetchStageList response status:', response.status);

    if (!response.ok) {
      throw new Error('Failed to fetch stage list');
    }
    console.log(String(competitionId))
    const data = await response.json();
    console.log('ResultsApi: fetchStageList data received:', data);
    return data;
  } catch (error) {
    console.error('Error fetching stage list:', error);
    return [];
  }
};

export const fetchStageResults = async (stageID) => {
  console.log('ResultsApi: fetchStageResults called with stageID:', stageID);
  try {
    const response = await fetch('https://www.admin.racepulse.pl/api/monitGetResultForStage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': 'UYwkNH50yAFoHI1mR62E',
      },
      body: JSON.stringify({
        StageID: stageID,
      }),
    });

    console.log('ResultsApi: fetchStageResults response status:', response.status);

    if (!response.ok) {
      throw new Error('Failed to fetch stage results');
    }

    const data = await response.json();
    console.log('ResultsApi: fetchStageResults data received:', data);
    return data;
  } catch (error) {
    console.error('Error fetching stage results:', error);
    return [];
  }
};